// extracted by mini-css-extract-plugin
module.exports = {"modalConntainer":"_2Spxp","modalConntainerImg":"_1NrQA","videoBox":"_1ooid","iframe":"_3YsN4"};